import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { UpdateBijbEventAction } from '../../actions/bijb-event/update-event-action';
import { UpdateBijbEventErrorAction } from '../../actions/bijb-event/update-event-error-action';
import { GetBijbEventsAction } from '../../actions/bijb-event/get-events-action';
import { GetBijbEventSuccessAction } from '../../actions/bijb-event/get-event-success-action';
import { from, of } from 'rxjs';

@Injectable()
export class UpdateBijbEventEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateEvent = createEffect(() => this.actions
    .pipe(
      ofType(UpdateBijbEventAction.type),
      mergeMap(action => {
        const updateEventAction = <UpdateBijbEventAction>action;
        return from(this.api.updateEvent(updateEventAction.bijbEvent))
          .pipe(
            mergeMap(bijbEvent => {
              return of(new GetBijbEventsAction(), new GetBijbEventSuccessAction(bijbEvent));
            }),
            catchError(e => {
              return of(new UpdateBijbEventErrorAction(e));
            })
          );
      })
    ));
}
